import * as Yup from 'yup'

export const initialValues = {
    class: '',
    manufacturer: '',
    model: '',
    serialNumber: '',
    shipToId: '',
    soldToId: '',
    customerUnitNumber: '',
    fuelType: '',
    additionalDetails: '',
    abcIndicator: 'C',
    origin: 'LiftOne Now',
    requestType: 'Create',
}

export const getInitialValues = user => {
    const userName = user?.first_name + ' ' + user?.last_name
    const soldToId = user?.company?.external_id
    return {
        user: {
            name: userName,
            id: user?.external_contact_id,
        },
        class: '',
        manufacturer: '',
        isMakeFromList: true,
        model: '',
        isModelFromList: true,
        serialNumber: '',
        shipToId: '',
        soldToId: soldToId,
        customerUnitNumber: '',
        fuelType: '',
        additionalDetails: '',
        abcIndicator: 'C',
        origin: 'LiftOne Now',
        requestType: 'Create',
    }
}

export const validationSchema = Yup.object().shape({
    class: Yup.string().required('Class field is required'),
    manufacturer: Yup.string().required('Manufacturer field is required'),
    model: Yup.string().required('Model is required'),
    serialNumber: Yup.string().required('Serial number is required'),
    fuelType: Yup.string().required('Fuel type is required'),
    shipToId: Yup.string().required('Location is required'),
    customerUnitNumber: Yup.string(),
    additionalDetails: Yup.string(),
    user: Yup.object(),
})
